import { render } from "./BsfpLiteratureView.vue?vue&type=template&id=45e94934&scoped=true"
import script from "./BsfpLiteratureView.vue?vue&type=script&lang=js"
export * from "./BsfpLiteratureView.vue?vue&type=script&lang=js"

import "./BsfpLiteratureView.vue?vue&type=style&index=0&id=45e94934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e94934"]])

export default __exports__